<template>
    <div>
        <div v-on:click="showModal">
            <ion-icon name="terminal"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Terminal"
                      class="mb--1"
            ></ion-icon>
        </div>
        <div class="modal fade terminal-modal" :id="getModalId" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog task-form" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <fieldset class="form-group tasks-started">
                            <legend class="close-modal">
                                <strong>Progress Logs</strong>
                                <p>{{ this.connection.name }}</p>
                                <div class="justify-content-end">
                                    <button class="btn close close-modal" data-dismiss="modal">
                                        <ion-icon name="close"></ion-icon>
                                    </button>
                                </div>
                            </legend>
                        </fieldset>
                        <div class="form-group d-flex controls mt-2">
                            <ul class="progress-block">
                                <li class='progress-message' v-for="log in currentLogs">
                                    <span class='progress-message-time'>{{ timeFormat(log.created_at) }}</span>
                                    <span :class="messageClasses(log.type)">{{ getLogText(log) }}</span>
                                </li>
                            </ul>
                        </div>
                        <div v-if="this.processingAndWaiting || this.processingFailed" class="modal-footer clearfix d-flex justify-content-end">
                            <app-button
                                v-show="this.processingFailed"
                                :link="this.route('connections.destroy', this.connection)"
                                type="error"
                                class="mt-2"
                                confirm-message="Are you sure?"
                                link-method="DELETE">
                                <ion-icon name="trash-outline"></ion-icon>
                                Delete
                            </app-button>
                            <button v-show="this.processingAndWaiting" class="btn btn-primary mt-2 mr-2 mb--2" @click="getLogs">Refresh</button>
                            <button v-show="this.processingAndWaiting && this.stopProcessingRouteName.length > 1" class="btn btn-danger mt-2" @click="stopProcessing">Stop Processing</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from "axios";

    export default {
        props: {
            connection: {
                type: Object,
                default: {}
            },
            processId: {
                type: Number,
                default: 0
            },
            logs: {
                type: Array,
                default() {
                    return [];
                }
            },
            error: {
                type: String,
                default: ''
            },
            possibleErrors: {
                type: Object,
                default: () => ({
                    'Cannot take token from IntelliBoard BE': 'In some reasons Supernova (IBNext) don’t return valid access token for get data from Canvas/D2L side. Please check connection credentials',
                    'Canvas Portal don\'t return any data file' : 'Canvas Portal cannot send list with files for aggregation. Usually it related with Canvas Portal problems.',
                    'Cannot take file list' : 'D2L Portal cannot send list with files for aggregation. Usually it related with D2L Portal problems.',
                    'Cannot decrypt incoming data' : 'Secret or host url is wrong in connection, so data can be decrypted',
                    'To many requests to Google API' : 'To many connection will goes trough Google API. Wail a little bit and continue processing.',
                    'LMS connection already processing.' : 'Connection already processing, please wait or cancel another processing.',
                    'LMS connection already in pending.' : 'Connection already in pending, please wait to start another processing.',
                    'Processing cannot be finish with server side troubles. Please try again later.' : 'Processing cannot be finish with server side troubles. Please try again later.',
                })
            },
            processingAndWaiting: {
                type: Boolean,
                default: false
            },
            processingFailed: {
                type: Boolean,
                default: false
            },
            showTerminalConnId: {
                type: Number,
                default: 0
            },
            getLogsRouteName: {
                type: String,
                default: 'jobs-progress.get-logs'
            },
            stopProcessingRouteName: {
                type: String,
                default: 'stop-processing'
            },
        },
        data() {
            return {
                currentLogs: this.logs
            }
        },
        mounted() {
            if (this.showTerminalConnId == this.connection.id && this.processingAndWaiting) {
                this.showModal();
            }
        },
        computed: {
            getModalId() {
                return 'terminal-modal' + this.connection.id + this.processId;
            }
        },
        methods: {
            showModal() {
                $('#terminal-modal' + this.connection.id + this.processId).modal('show');
            },
            timeFormat(timestamp) {
                return '[' + dayjs(timestamp).format('YYYY.MM.DD HH:mm:ss z') + ']';
            },
            messageClasses(type) {
                const allowedClasses = {0: 'error', 1: 'success', 2: 'error'},
                    typeClass = allowedClasses[type] || 'success';

                return 'progress-message-text ' + typeClass;
            },
            getLogText(log) {
                if ((log.type === 1) || (log.type === 3)) {
                    return log.message;
                }

                if (this.possibleErrors[this.error] !== undefined) {
                    return this.error + "\n" + this.possibleErrors[this.error];
                } else {
                    return this.error;
                }

                return lang('undefined_error', 'processHistories');
            },
            stopProcessing() {
                return axios.get(this.route(this.stopProcessingRouteName, this.processId))
                .then(() => {
                    document.location.href = this.route('jobs-progress.index');
                })
            },
            getLogs() {
                return axios.get(this.route(this.getLogsRouteName, {process_id: this.processId}))
                .then(response => {
                    this.currentLogs = response.data.logs;
                })
            }
        }
    }

</script>

<style scoped lang="scss">
@import "../../sass/_variables.scss";

div.terminal-modal {
    ul {
        min-height: 100%;
        padding: 20px;
        background-color: #18171b;

        .progress-message {
            font: 12px Menlo,Monaco,Consolas,monospace;
            line-height: 1.3em;
            white-space: pre-wrap;
            font-weight: 700;

            .progress-message-time {
                color: #1299da;
            }

            .progress-message-text.success {
                color: #56db3a;
            }

            .progress-message-text.error {
                color: #d9534f;
            }
        }
    }

    button {
        font-weight: 500;
    }

    button.btn.close.close-modal {
        top: -70px;
        position: relative;
    }

    legend.close-modal {
        max-height: 55px;
    }

    .modal-footer {
        padding: 0;
    }

    .modal-footer > * {
        margin: 0;
    }
}

</style>

